import { useState, useRef, useEffect } from 'react';
import { DataMap, DropdownProps } from './types';
import jquery from 'jquery';
import './style.scss';

const Dropdown = (props: DropdownProps) => {
  const { placeholder, data, inputField, defaultValue, style, action, className, mainClassName, keyToSet = 'value' } = props;
  const dropdownRef = useRef(null);
  const divRef = useRef(null);
  const [toggle, setToggle] = useState<boolean>(false);
  const [value, setValue] = useState<string | null>(defaultValue || null);
  const toggleDropdown = () => {
    setToggle(prevState => !prevState);
  };
  const handleClick = (e: any) => {
    const wrapper = dropdownRef.current || ({} as HTMLDivElement);
    let expectedDiv: any = jquery(e.target).is('.dropdown__wrapper');
    if (!expectedDiv) {
      expectedDiv = jquery(e.target).closest('.dropdown__wrapper').get(0);
    } else {
      expectedDiv = e.target;
    }
    if (wrapper.contains(e.target) || expectedDiv === divRef.current) {
      return;
    }
    setToggle(false);
  };

  /*  useEffect(() => {
    if (upperCase && value) {
      setValue(value.toUpperCase());
    }
  }, [value]);*/

  const setTextValue = (val: string | undefined) => {
    if (val) {
      if (keyToSet !== 'value') {
        const obj: any = data.find((each: any) => {
          if (each && each.value) {
            return each.value === String(val);
          }
        });
        setValue(obj ? obj[keyToSet] : '');
      } else {
        setValue(String(val));
      }
    }
  };
  const selectLocation = (val: string) => {
    if (val) {
      action(val);
      setTextValue(val);

      toggleDropdown();
    }
  };
  useEffect(() => {
    document.addEventListener('mousedown', handleClick);
    return () => {
      document.removeEventListener('mousedown', handleClick);
    };
  }, []);
  useEffect(() => {
    setTextValue(defaultValue);
  }, [defaultValue]);

  return (
    <div className={`dropdown ${!!mainClassName ? mainClassName : ''}`}>
      {inputField ? (
        <div className={`dropdown__wrapper ${toggle ? 'active' : ''} ${className || ''}`} onClick={toggleDropdown} ref={divRef} style={style}>
          <input placeholder={placeholder} className="dropdown__input capitalize" readOnly value={value || defaultValue || ''} />
          {toggle ? (
            <i className="fa fa-chevron-up dropdown_icon ml-2" aria-hidden="true" />
          ) : (
            <i className="fa fa-chevron-down dropdown_icon ml-2" aria-hidden="true" />
          )}
        </div>
      ) : (
        <button ref={divRef} type="button" className={`dropdown__btn ${toggle ? 'active' : ''}`} onClick={toggleDropdown}>
          {placeholder || 'Dropdown'}
        </button>
      )}

      <div className={`dropdown__container ${toggle ? 'active' : ''}`} ref={dropdownRef}>
        <ul>
          {data.map((d: DataMap, index: number) => (
            <li key={index.toString()} className={d.value === (value || defaultValue || '') ? 'active' : ''}>
              <button onClick={() => selectLocation(d.value)} data-value={d.value}>
                <span className={'capitalize'}>{d.text}</span>
              </button>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default Dropdown;
